import type { ErrorBoundaryProps } from '@sentry/react';
import { ErrorBoundary } from '@sentry/react';
import { Suspense } from 'react';
import { Outlet } from 'react-router';
import { handleError } from '../../blocks/Error';
import Footer from '../../blocks/Footer';
import Loader from '../../common/Loader';

const beforeCapture: ErrorBoundaryProps['beforeCapture'] = scope => {
    scope.setTag('boundary', 'CenteredLayout');
};

const waveUrl = new URL('@/public/images/dashboard-welcome-wave.png', import.meta.url).href;

const CenteredLayout = () => (
    <div className="bg-neutral-0 relative h-screen w-screen overflow-auto">
        <div className="relative flex min-h-[calc(100vh-64px)] items-center justify-center">
            <ErrorBoundary beforeCapture={beforeCapture} fallback={handleError}>
                <Suspense fallback={<Loader />}>
                    <Outlet />
                </Suspense>
            </ErrorBoundary>
            <div
                aria-hidden="true"
                className="pointer-events-none absolute right-0 bottom-0 h-80 w-full bg-size-[300%_100%] bg-position-[-260px_0px] bg-no-repeat md:h-120 md:bg-size-[100%_100%] md:bg-position-[0px_0px]"
                style={{ backgroundImage: `url(${waveUrl})` }}
            />
        </div>
        <Footer layoutStyle="CenteredLayout" />
    </div>
);

export default CenteredLayout;
